import {Component, computed, inject} from '@angular/core';
import {MatMenuModule} from '@angular/material/menu';
import {NotificationService} from '@infrastructure/notifications/notifications.service';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {NotificationItemComponent} from './notification-item/notification-item.component';

@Component({
    selector: 'app-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrl: './notification-center.component.scss',
    standalone: true,
    imports: [
        AngularSvgIconModule,
        TranslateModule,
        MatMenuModule,
        NotificationItemComponent
    ]
})
export class NotificationCenterComponent
{
    private readonly notificationService = inject(NotificationService);

    public readonly notifications = computed(() => this.notificationService.notifications());

    public readonly total = computed(() => this.notificationService.total());

    public constructor()
    {
        this.notificationService.getNotifications();
    }

    public markAsRead(id: string): void
    {
        this.notificationService.markAsRead(id);
    }
}
